import type { Route } from '@angular/router';
import { NotFoundComponent } from '@comparit/core';
import { ShellComponent } from './shell.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: ShellComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'formular',
      },
      {
        path: 'formular',
        loadChildren: () => import('./formular/formular.routes').then(r => r.formularRoutes),
      },
      {
        path: 'rechner',
        loadComponent: () => import('./results/results.component').then(c => c.ResultsComponent),
      },
      {
        path: 'vergleich',
        loadComponent: () =>
          import('./vergleich/vergleich.component').then(c => c.VergleichComponent),
      },
      {
        path: 'tarifdetails-laden',
        loadComponent: () =>
          import('./tarifdetails/tarifdetails-laden/tarifdetails-laden.component').then(
            c => c.TarifdetailsLadenComponent
          ),
      },
      {
        path: 'tarifdetails/:vorgangId',
        loadComponent: () =>
          import('./tarifdetails/tarifdetails.component').then(c => c.TarifdetailsComponent),
      },
    ],
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
